export type OutboundCallErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'UNKNOWN';

export class OutboundCallError extends Error {
    code: OutboundCallErrorCode;

    constructor(code: OutboundCallErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
